var React = require('react');

function SortDescIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","fill":"white","key":0}),React.createElement("path",{"d":"M8 4V12M8 12L5 9M8 12L11 9","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SortDescIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SortDescIcon;

SortDescIcon.default = SortDescIcon;
